module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_5.6930e968.png";